import script from "./Footer-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer-item.vue?vue&type=script&setup=true&lang=js"

import "./Footer-item.vue?vue&type=style&index=0&id=29f21358&lang=css"

const __exports__ = script;

export default __exports__